// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:04:17

export default {
  "id": "flip-knife",
  "slug": "flip-knife",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8a6f9da126134bb8990235afb09d5264-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8a6f9da126134bb8990235afb09d5264/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Flip Knife",
      "description": "Explore different rooms, jump on all sorts of objects: shelves, tables, chairs, sofas, and even subwoofers!Make the knife jump or even double flip. How? Just tap the screen at the right moment and jump!\n",
      "instructions": "\nTap the screen at the right moment and jump",
      "genres": [
        "Casual"
      ],
      "tags": [
        "flip",
        "jumping",
        "knife"
      ]
    },
    "zh-CN": {
      "title": "翻刀",
      "description": "探索不同房间，跳上各种物体：架子、桌子、椅子、沙发，甚至低音炮！让刀子跳跃或甚至双翻。怎么做？只需在正确的时间点击屏幕跳跃！",
      "instructions": "在正确时机轻触屏幕进行跳跃",
      "genres": [
        "休闲"
      ],
      "tags": [
        "翻滚",
        "跳跃",
        "刀"
      ]
    },
    "zh-TW": {
      "title": "翻刀",
      "description": "探索不同的房間，跳上各式各樣的物件：架子、桌子、椅子、沙發，甚至低音炮！讓刀子跳躍或進行雙重翻轉。怎麼辦？只需在正確的時機點擊屏幕並跳躍即可！",
      "instructions": "在適當的時機點擊螢幕並跳躍",
      "genres": [
        "隨意"
      ],
      "tags": [
        "翻轉",
        "跳躍",
        "刀"
      ]
    },
    "zh-HK": {
      "title": "翻刀",
      "description": "探索不同房間，跳上各式各樣的物件：櫥櫃、桌子、椅子、沙發，甚至低音炮！讓刀子跳躍或甚至雙重翻轉。怎麼辦？只需在正確時機點擊螢幕並跳躍！",
      "instructions": "按擊畫面於正確時機並跳躍",
      "genres": [
        "隨意"
      ],
      "tags": [
        "翻轉",
        "跳躍",
        "飛刀"
      ]
    },
    "ja": {
      "title": "フリップナイフ",
      "description": "異なる部屋を探索し、様々なオブジェクトに飛び乗れ：棚、テーブル、椅子、ソファー、サブウーファーまで！ナイフをジャンプさせたり、ダブルフリップにしよう。どうやるの？スクリーンを正しいタイミングでタップしてジャンプするだけ！",
      "instructions": "正しいタイミングで画面をタップしてジャンプしてください",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "フリップ",
        "ジャンプ",
        "ナイフ"
      ]
    },
    "ko": {
      "title": "플립 낫",
      "description": "다양한 방을 탐험하고, 모든 종류의 물체에 뛰어 올라가세요: 책장, 테이블, 의자, 소파, 심지어 서브웨이버까지! 칼을 뛰어 올리거나 더블 플립을 시도해보세요. 어떻게 하면 될까요? 간단합니다. 화면을 적절한 시기에 탭하고 뛰어 올리세요!",
      "instructions": "적절한 시기에 화면을 탭하고 점프하세요",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "플립",
        "점프",
        "칼"
      ]
    },
    "fr": {
      "title": "Couteau à levier",
      "description": "Explorez différentes chambres, sautez sur toutes sortes d'objets : étagères, tables, chaises, canapés et même des woofers ! Faites sauter le couteau ou même effectuez un double flip. Comment ? Il suffit de tapoter l'écran au bon moment et de sauter !",
      "instructions": "Tapez sur l'écran au bon moment et sautez",
      "genres": [
        "Casual"
      ],
      "tags": [
        "flip",
        "saut",
        "couteau"
      ]
    }
  }
};
